import { memo } from 'react';
import { ComponentMemo } from '@headless-workspace/typings';
import { GlowTextBody, PropsWithClassName } from '../../../../src';
import { GlowList } from './GlowList';

type GlowTextListProps = PropsWithClassName & {
    texts: string[];
};

export const GlowTextList: ComponentMemo<GlowTextListProps> = memo(({ texts, className }) => {
    return (
        <GlowList
            items={texts}
            className={className}
            renderItem={(text) => <GlowTextBody text={text} className={'inline'} />}
        />
    );
});

GlowTextList.displayName = 'GlowTextList';
